import { render, staticRenderFns } from "./UserAssignedDid.vue?vue&type=template&id=583c139f&scoped=true&"
import script from "./UserAssignedDid.vue?vue&type=script&lang=js&"
export * from "./UserAssignedDid.vue?vue&type=script&lang=js&"
import style0 from "./UserAssignedDid.vue?vue&type=style&index=0&id=583c139f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c139f",
  null
  
)

component.options.__file = "UserAssignedDid.vue"
export default component.exports